export const ShoplColorSet = {
  '--sendbird-light-primary-500': '#2D89E4',
  '--sendbird-light-primary-400': '#2D89E4',
  '--sendbird-light-primary-300': '#3299FE',
  '--sendbird-light-primary-200': '#84C2FC',
  '--sendbird-light-primary-100': '#D6E9FB',
  '--sendbird-light-secondary-500': '#05A77B',
  '--sendbird-light-secondary-400': '#02B585',
  '--sendbird-light-secondary-300': '#61CBB5',
  '--sendbird-light-secondary-200': '#C1E7DD',
  '--sendbird-light-secondary-100': '#D9F4ED',
  '--sendbird-light-error-400': '#FF6666',
  '--sendbird-light-error-300': '#FF7979',
  '--sendbird-light-error-200': '#FF7979',
  '--sendbird-light-error-100': '#F9EBEB',
  '--sendbird-light-background-700': '#333333',
  '--sendbird-light-background-600': '#555555',
  '--sendbird-light-background-500': '#777777',
  '--sendbird-light-background-400': '#999999',
  '--sendbird-light-background-300': '#DDDDDD',
  '--sendbird-light-background-200': '#EAEAEA',
  '--sendbird-light-background-100': '#F9F9F9',

  '--sendbird-dark-primary-500': '#2D89E4',
  '--sendbird-dark-primary-400': '#2D89E4',
  '--sendbird-dark-primary-300': '#3299FE',
  '--sendbird-dark-primary-200': '#84C2FC',
  '--sendbird-dark-primary-100': '#D6E9FB',
  '--sendbird-dark-secondary-500': '#05A77B',
  '--sendbird-dark-secondary-400': '#02B585',
  '--sendbird-dark-secondary-300': '#61CBB5',
  '--sendbird-dark-secondary-200': '#C1E7DD',
  '--sendbird-dark-secondary-100': '#D9F4ED',
  '--sendbird-dark-error-400': '#FF6666',
  '--sendbird-dark-error-300': '#FF7979',
  '--sendbird-dark-error-200': '#FF7979',
  '--sendbird-dark-error-100': '#F9EBEB',

  '--sendbird-tooltip-background': '#333333',
  '--sendbird-message-input-border-active': '#3299FE',
  '--sendbird-iconbutton-color': '#84C2FC',
  '--sendbird-selected-reaction-button-border-hover': '#D6E9FB',
  '--sendbird-add-reaction-button-border-hover': '#D6E9FB',
} as const;
